import { EditorState } from 'src/store/editor/types';

const resetFormatSelectorValuesReducer = (state: EditorState) => {
  state.formatSelectors = {};
};

export default resetFormatSelectorValuesReducer;
